exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#PersonsPicker {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 2vh;\n  max-height: 56vh;\n  overflow: auto;\n}\n#PersonsPicker .number {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1 0 21%;\n  max-width: 22%;\n  margin: 5px 5px 5vh 5px;\n  height: 26px;\n  border: 1px solid #8598B0;\n  border-radius: 15px;\n  background-color: #FFFFFF;\n}\n#PersonsPicker .number.selected {\n  border: 0;\n  color: white;\n  background-color: #E12968;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/reservation/Reservation.Persons.less
// module id = 1380
// module chunks = 0